import React, { useState } from "react";
import { Paginator } from "primereact/paginator";
import { Dropdown } from "primereact/dropdown";

export default function PaginatorCom({ paginatorData, onPaginatorClick }) {
  const [first, setFirst] = useState(paginatorData?.first || 0);
  const [rows, setRows] = useState(paginatorData?.rows || 5);

  const onPageChange = (e) => {
    setFirst(e.first);
    setRows(e.rows);
    onPaginatorClick?.(e);
  };

  const template = {
    layout: "RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink",
    RowsPerPageDropdown: (options) => (
      <>
        <span className="mx-2">Items per page:</span>
        <Dropdown
          value={rows}
          options={[5, 10, 20, 50].map((v) => ({ label: v, value: v }))}
          onChange={(e) => onPageChange({ first: 0, rows: e.value })}
        />
      </>
    ),
    CurrentPageReport: (options) => (
      <span className="mx-3">
        {options.first + 1} - {options.last} of {options.totalRecords}
      </span>
    ),
  };

  return (
    <Paginator
      first={first}
      rows={rows}
      totalRecords={paginatorData?.totalCount || 0}
      onPageChange={onPageChange}
      template={template}
    />
  );
}